export default function () {
  return {
    activeIndex: this.menuSlider ? this.menuSlider.activeIndex : 0,
    slidesPerView: this.menuSlider ? this.menuSlider.params.slidesPerView : 'all'
  };
}
